import { c as _c } from "react/compiler-runtime";
import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BookOpenIcon from '@/assets/icons/heroIcons/Book-open.svg';
import BriefcaseIcon from '@/assets/icons/heroIcons/Briefcase.svg';
import ChatIcon from '@/assets/icons/heroIcons/Chat.svg';
import ClipboardIcon from '@/assets/icons/heroIcons/Clipboard.svg';
import DesktopComputerIcon from '@/assets/icons/heroIcons/Desktop-computer.svg';
import NewspaperIcon from '@/assets/icons/heroIcons/Newspaper.svg';
import PhoneIcon from '@/assets/icons/heroIcons/Phone.svg';
import CashbackIcon from '@/assets/icons/heroIcons/Discount.svg';
import TagIcon from '@/assets/icons/heroIcons/Tag.svg';
import ShoppingCartIcon from '@/assets/icons/heroIcons/Shopping-cart.svg';
import SpeakerphoneIcon from '@/assets/icons/heroIcons/Speakerphone.svg';
import TemplateIcon from '@/assets/icons/heroIcons/Template.svg';
import HandshakeIcon from '@/assets/icons/heroIcons/Handshake.svg';
import ThirdIcon from '@/assets/icons/heroIcons/Third.svg';
import CardFrontIcon from '@/assets/icons/heroIcons/Card-front.svg';
import DeferredPaymentIcon from '@/assets/icons/heroIcons/Deferred-payment.svg';
import LoanIcon from '@/assets/icons/heroIcons/Loan.svg';
import PayIcon from '@/assets/icons/heroIcons/Pay.svg';
import UserGroupIcon from '@/assets/icons/heroIcons/User-group.svg';
import MobileAppIcon from '@/assets/icons/heroIcons/Device-mobile.svg';
import ViewGridIcon from '@/assets/icons/heroIcons/View-grid.svg';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
type SectionBase = {
  id: 'products' | 'deferredPayment' | 'payInThree' | 'card' | 'loan' | 'revolving' | 'allProducts' | 'whereToShop' | 'promotionsAndDiscounts' | 'promotions' | 'discounts' | 'cashback' | 'implementation' | 'forEshops' | 'forDevelopers' | 'aboutUs' | 'aboutCompany' | 'forMedia' | 'career' | 'blog' | 'other' | 'faq' | 'pricing' | 'contact' | 'mobileApp' | 'gcssLandingPage' | 'checkoutManual' | 'termsAndConditions';
  name: string;
  promo?: PageMenuPromoBanner;
};
export type SubSection = SectionBase & {
  description: string;
  icon: ReactNode;
  path: string;
};
export type Section = ({
  path: string;
} | {
  subsection: SubSection[];
}) & SectionBase;
export function useSections() {
  const $ = _c(532);
  const {
    t
  } = useTranslation();
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t0;
  if ($[0] !== t) {
    t0 = t("products");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("products.deferredPayment.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DeferredPaymentIcon />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("products.deferredPayment");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = LINKS();
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3) {
    t5 = {
      id: "deferredPayment",
      description: t1,
      icon: t2,
      name: t3,
      path: t4.deferredPayment
    };
    $[8] = t1;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("products.payInThree.description");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ThirdIcon />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("products.payInThree");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = LINKS();
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t8) {
    t10 = {
      id: "payInThree",
      description: t6,
      icon: t7,
      name: t8,
      path: t9.payInThree
    };
    $[17] = t6;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("products.card.description");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <CardFrontIcon />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t) {
    t13 = t("products.card");
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = LINKS();
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t13) {
    t15 = {
      id: "card",
      description: t11,
      icon: t12,
      name: t13,
      path: t14.card
    };
    $[26] = t11;
    $[27] = t13;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t) {
    t16 = t("products.loan.description");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <LoanIcon />;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t) {
    t18 = t("products.loan.short");
    $[32] = t;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = LINKS();
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t16 || $[36] !== t18) {
    t20 = {
      id: "loan",
      description: t16,
      icon: t17,
      name: t18,
      path: t19.loan
    };
    $[35] = t16;
    $[36] = t18;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t) {
    t21 = t("products.allProducts.description");
    $[38] = t;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <ViewGridIcon />;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t) {
    t23 = t("products.allProducts");
    $[41] = t;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = LINKS();
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t21 || $[45] !== t23) {
    t25 = {
      id: "allProducts",
      description: t21,
      icon: t22,
      name: t23,
      path: t24.productsPackages
    };
    $[44] = t21;
    $[45] = t23;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== t10 || $[48] !== t15 || $[49] !== t20 || $[50] !== t25 || $[51] !== t5) {
    t26 = [t5, t10, t15, t20, t25];
    $[47] = t10;
    $[48] = t15;
    $[49] = t20;
    $[50] = t25;
    $[51] = t5;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t0 || $[54] !== t26) {
    t27 = {
      id: "products",
      name: t0,
      subsection: t26
    };
    $[53] = t0;
    $[54] = t26;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t) {
    t28 = t("products.whereToShop");
    $[56] = t;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = LINKS();
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t28) {
    t30 = {
      id: "whereToShop",
      name: t28,
      path: t29.whereToShop
    };
    $[59] = t28;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t) {
    t31 = t("products.promotionsAndDiscounts");
    $[61] = t;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t) {
    t32 = t("products.promotions.description");
    $[63] = t;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  let t33;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <TagIcon />;
    $[65] = t33;
  } else {
    t33 = $[65];
  }
  let t34;
  if ($[66] !== t) {
    t34 = t("products.promotions");
    $[66] = t;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = LINKS();
    $[68] = t35;
  } else {
    t35 = $[68];
  }
  let t36;
  if ($[69] !== t32 || $[70] !== t34) {
    t36 = {
      id: "promotions",
      description: t32,
      icon: t33,
      name: t34,
      path: t35.promotions
    };
    $[69] = t32;
    $[70] = t34;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  let t37;
  if ($[72] !== t) {
    t37 = t("products.discounts.description");
    $[72] = t;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <SpeakerphoneIcon />;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] !== t) {
    t39 = t("products.discounts");
    $[75] = t;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = EXTERNAL_LINKS();
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] !== t37 || $[79] !== t39) {
    t41 = {
      id: "discounts",
      description: t37,
      icon: t38,
      name: t39,
      path: t40.marketingPromos
    };
    $[78] = t37;
    $[79] = t39;
    $[80] = t41;
  } else {
    t41 = $[80];
  }
  let t42;
  if ($[81] !== t) {
    t42 = t("products.cashback.description");
    $[81] = t;
    $[82] = t42;
  } else {
    t42 = $[82];
  }
  let t43;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <CashbackIcon />;
    $[83] = t43;
  } else {
    t43 = $[83];
  }
  let t44;
  if ($[84] !== t) {
    t44 = t("products.cashback");
    $[84] = t;
    $[85] = t44;
  } else {
    t44 = $[85];
  }
  let t45;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = EXTERNAL_LINKS();
    $[86] = t45;
  } else {
    t45 = $[86];
  }
  let t46;
  if ($[87] !== t42 || $[88] !== t44) {
    t46 = {
      id: "cashback",
      description: t42,
      icon: t43,
      name: t44,
      path: t45.cashback
    };
    $[87] = t42;
    $[88] = t44;
    $[89] = t46;
  } else {
    t46 = $[89];
  }
  let t47;
  if ($[90] !== t36 || $[91] !== t41 || $[92] !== t46) {
    t47 = [t36, t41, t46];
    $[90] = t36;
    $[91] = t41;
    $[92] = t46;
    $[93] = t47;
  } else {
    t47 = $[93];
  }
  let t48;
  if ($[94] !== t31 || $[95] !== t47) {
    t48 = {
      id: "promotionsAndDiscounts",
      name: t31,
      subsection: t47
    };
    $[94] = t31;
    $[95] = t47;
    $[96] = t48;
  } else {
    t48 = $[96];
  }
  let t49;
  if ($[97] !== t) {
    t49 = t("products.implementation");
    $[97] = t;
    $[98] = t49;
  } else {
    t49 = $[98];
  }
  let t50;
  if ($[99] !== t) {
    t50 = t("products.forEshops.description");
    $[99] = t;
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  let t51;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <HandshakeIcon />;
    $[101] = t51;
  } else {
    t51 = $[101];
  }
  let t52;
  if ($[102] !== t) {
    t52 = t("products.forEshops");
    $[102] = t;
    $[103] = t52;
  } else {
    t52 = $[103];
  }
  let t53;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = LINKS();
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  let t54;
  if ($[105] !== t50 || $[106] !== t52) {
    t54 = {
      id: "forEshops",
      description: t50,
      icon: t51,
      name: t52,
      path: t53.forEshops
    };
    $[105] = t50;
    $[106] = t52;
    $[107] = t54;
  } else {
    t54 = $[107];
  }
  let t55;
  if ($[108] !== t) {
    t55 = t("products.forDevelopers.description");
    $[108] = t;
    $[109] = t55;
  } else {
    t55 = $[109];
  }
  let t56;
  if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <DesktopComputerIcon />;
    $[110] = t56;
  } else {
    t56 = $[110];
  }
  let t57;
  if ($[111] !== t) {
    t57 = t("products.forDevelopers");
    $[111] = t;
    $[112] = t57;
  } else {
    t57 = $[112];
  }
  let t58;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = LINKS();
    $[113] = t58;
  } else {
    t58 = $[113];
  }
  let t59;
  if ($[114] !== t55 || $[115] !== t57) {
    t59 = {
      id: "forDevelopers",
      description: t55,
      icon: t56,
      name: t57,
      path: t58.forDevelopers
    };
    $[114] = t55;
    $[115] = t57;
    $[116] = t59;
  } else {
    t59 = $[116];
  }
  let t60;
  if ($[117] !== t) {
    t60 = t("products.gcss.description");
    $[117] = t;
    $[118] = t60;
  } else {
    t60 = $[118];
  }
  let t61;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <ShoppingCartIcon />;
    $[119] = t61;
  } else {
    t61 = $[119];
  }
  let t62;
  if ($[120] !== t) {
    t62 = t("products.gcss");
    $[120] = t;
    $[121] = t62;
  } else {
    t62 = $[121];
  }
  let t63;
  if ($[122] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = LINKS();
    $[122] = t63;
  } else {
    t63 = $[122];
  }
  let t64;
  if ($[123] !== t60 || $[124] !== t62) {
    t64 = {
      id: "gcssLandingPage",
      description: t60,
      icon: t61,
      name: t62,
      path: t63.gcssLandingPage
    };
    $[123] = t60;
    $[124] = t62;
    $[125] = t64;
  } else {
    t64 = $[125];
  }
  let t65;
  if ($[126] !== t) {
    t65 = t("products.checkoutManual.description");
    $[126] = t;
    $[127] = t65;
  } else {
    t65 = $[127];
  }
  let t66;
  if ($[128] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <TemplateIcon />;
    $[128] = t66;
  } else {
    t66 = $[128];
  }
  let t67;
  if ($[129] !== t) {
    t67 = t("products.checkoutManual");
    $[129] = t;
    $[130] = t67;
  } else {
    t67 = $[130];
  }
  let t68;
  if ($[131] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = EXTERNAL_LINKS();
    $[131] = t68;
  } else {
    t68 = $[131];
  }
  let t69;
  if ($[132] !== t65 || $[133] !== t67) {
    t69 = {
      id: "checkoutManual",
      description: t65,
      icon: t66,
      name: t67,
      path: t68.checkoutManual
    };
    $[132] = t65;
    $[133] = t67;
    $[134] = t69;
  } else {
    t69 = $[134];
  }
  let t70;
  if ($[135] !== t54 || $[136] !== t59 || $[137] !== t64 || $[138] !== t69) {
    t70 = [t54, t59, t64, t69];
    $[135] = t54;
    $[136] = t59;
    $[137] = t64;
    $[138] = t69;
    $[139] = t70;
  } else {
    t70 = $[139];
  }
  let t71;
  if ($[140] !== t49 || $[141] !== t70) {
    t71 = {
      id: "implementation",
      name: t49,
      subsection: t70
    };
    $[140] = t49;
    $[141] = t70;
    $[142] = t71;
  } else {
    t71 = $[142];
  }
  let t72;
  if ($[143] !== t) {
    t72 = t("products.aboutUs");
    $[143] = t;
    $[144] = t72;
  } else {
    t72 = $[144];
  }
  let t73;
  if ($[145] !== t) {
    t73 = t("products.aboutCompany.description");
    $[145] = t;
    $[146] = t73;
  } else {
    t73 = $[146];
  }
  let t74;
  if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
    t74 = <UserGroupIcon />;
    $[147] = t74;
  } else {
    t74 = $[147];
  }
  let t75;
  if ($[148] !== t) {
    t75 = t("products.aboutCompany");
    $[148] = t;
    $[149] = t75;
  } else {
    t75 = $[149];
  }
  let t76;
  if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = LINKS();
    $[150] = t76;
  } else {
    t76 = $[150];
  }
  let t77;
  if ($[151] !== t73 || $[152] !== t75) {
    t77 = {
      id: "aboutCompany",
      description: t73,
      icon: t74,
      name: t75,
      path: t76.aboutCompany
    };
    $[151] = t73;
    $[152] = t75;
    $[153] = t77;
  } else {
    t77 = $[153];
  }
  let t78;
  if ($[154] !== t) {
    t78 = t("products.forMedia.description");
    $[154] = t;
    $[155] = t78;
  } else {
    t78 = $[155];
  }
  let t79;
  if ($[156] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <BookOpenIcon />;
    $[156] = t79;
  } else {
    t79 = $[156];
  }
  let t80;
  if ($[157] !== t) {
    t80 = t("products.forMedia");
    $[157] = t;
    $[158] = t80;
  } else {
    t80 = $[158];
  }
  let t81;
  if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
    t81 = LINKS();
    $[159] = t81;
  } else {
    t81 = $[159];
  }
  let t82;
  if ($[160] !== t78 || $[161] !== t80) {
    t82 = {
      id: "forMedia",
      description: t78,
      icon: t79,
      name: t80,
      path: t81.forMedia
    };
    $[160] = t78;
    $[161] = t80;
    $[162] = t82;
  } else {
    t82 = $[162];
  }
  let t83;
  if ($[163] !== t) {
    t83 = t("products.career.description");
    $[163] = t;
    $[164] = t83;
  } else {
    t83 = $[164];
  }
  let t84;
  if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
    t84 = <BriefcaseIcon />;
    $[165] = t84;
  } else {
    t84 = $[165];
  }
  let t85;
  if ($[166] !== t) {
    t85 = t("products.career");
    $[166] = t;
    $[167] = t85;
  } else {
    t85 = $[167];
  }
  let t86;
  if ($[168] === Symbol.for("react.memo_cache_sentinel")) {
    t86 = LINKS();
    $[168] = t86;
  } else {
    t86 = $[168];
  }
  let t87;
  if ($[169] !== t83 || $[170] !== t85) {
    t87 = {
      id: "career",
      description: t83,
      icon: t84,
      name: t85,
      path: t86.career
    };
    $[169] = t83;
    $[170] = t85;
    $[171] = t87;
  } else {
    t87 = $[171];
  }
  let t88;
  if ($[172] !== t) {
    t88 = t("products.blog.description");
    $[172] = t;
    $[173] = t88;
  } else {
    t88 = $[173];
  }
  let t89;
  if ($[174] === Symbol.for("react.memo_cache_sentinel")) {
    t89 = <NewspaperIcon />;
    $[174] = t89;
  } else {
    t89 = $[174];
  }
  let t90;
  if ($[175] !== t) {
    t90 = t("products.blog");
    $[175] = t;
    $[176] = t90;
  } else {
    t90 = $[176];
  }
  let t91;
  if ($[177] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = EXTERNAL_LINKS();
    $[177] = t91;
  } else {
    t91 = $[177];
  }
  let t92;
  if ($[178] !== t88 || $[179] !== t90) {
    t92 = {
      id: "blog",
      description: t88,
      icon: t89,
      name: t90,
      path: t91.blog
    };
    $[178] = t88;
    $[179] = t90;
    $[180] = t92;
  } else {
    t92 = $[180];
  }
  let t93;
  if ($[181] !== t77 || $[182] !== t82 || $[183] !== t87 || $[184] !== t92) {
    t93 = [t77, t82, t87, t92];
    $[181] = t77;
    $[182] = t82;
    $[183] = t87;
    $[184] = t92;
    $[185] = t93;
  } else {
    t93 = $[185];
  }
  let t94;
  if ($[186] !== t72 || $[187] !== t93) {
    t94 = {
      id: "aboutUs",
      name: t72,
      subsection: t93
    };
    $[186] = t72;
    $[187] = t93;
    $[188] = t94;
  } else {
    t94 = $[188];
  }
  let t95;
  if ($[189] !== t) {
    t95 = t("products.other");
    $[189] = t;
    $[190] = t95;
  } else {
    t95 = $[190];
  }
  let t96;
  if ($[191] !== t) {
    t96 = t("products.faq.description");
    $[191] = t;
    $[192] = t96;
  } else {
    t96 = $[192];
  }
  let t97;
  if ($[193] === Symbol.for("react.memo_cache_sentinel")) {
    t97 = <ChatIcon />;
    $[193] = t97;
  } else {
    t97 = $[193];
  }
  let t98;
  if ($[194] !== t) {
    t98 = t("products.faq");
    $[194] = t;
    $[195] = t98;
  } else {
    t98 = $[195];
  }
  let t99;
  if ($[196] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = LINKS();
    $[196] = t99;
  } else {
    t99 = $[196];
  }
  let t100;
  if ($[197] !== t96 || $[198] !== t98) {
    t100 = {
      id: "faq",
      description: t96,
      icon: t97,
      name: t98,
      path: t99.faq
    };
    $[197] = t96;
    $[198] = t98;
    $[199] = t100;
  } else {
    t100 = $[199];
  }
  let t101;
  if ($[200] !== t) {
    t101 = t("products.pricing.description");
    $[200] = t;
    $[201] = t101;
  } else {
    t101 = $[201];
  }
  let t102;
  if ($[202] === Symbol.for("react.memo_cache_sentinel")) {
    t102 = <PayIcon />;
    $[202] = t102;
  } else {
    t102 = $[202];
  }
  let t103;
  if ($[203] !== t) {
    t103 = t("products.pricing");
    $[203] = t;
    $[204] = t103;
  } else {
    t103 = $[204];
  }
  let t104;
  if ($[205] === Symbol.for("react.memo_cache_sentinel")) {
    t104 = LINKS();
    $[205] = t104;
  } else {
    t104 = $[205];
  }
  let t105;
  if ($[206] !== t101 || $[207] !== t103) {
    t105 = {
      id: "pricing",
      description: t101,
      icon: t102,
      name: t103,
      path: t104.pricing
    };
    $[206] = t101;
    $[207] = t103;
    $[208] = t105;
  } else {
    t105 = $[208];
  }
  let t106;
  if ($[209] !== t) {
    t106 = t("products.contact.description");
    $[209] = t;
    $[210] = t106;
  } else {
    t106 = $[210];
  }
  let t107;
  if ($[211] === Symbol.for("react.memo_cache_sentinel")) {
    t107 = <PhoneIcon />;
    $[211] = t107;
  } else {
    t107 = $[211];
  }
  let t108;
  if ($[212] !== t) {
    t108 = t("products.contact");
    $[212] = t;
    $[213] = t108;
  } else {
    t108 = $[213];
  }
  let t109;
  if ($[214] === Symbol.for("react.memo_cache_sentinel")) {
    t109 = LINKS();
    $[214] = t109;
  } else {
    t109 = $[214];
  }
  let t110;
  if ($[215] !== t106 || $[216] !== t108) {
    t110 = {
      id: "contact",
      description: t106,
      icon: t107,
      name: t108,
      path: t109.contact
    };
    $[215] = t106;
    $[216] = t108;
    $[217] = t110;
  } else {
    t110 = $[217];
  }
  let t111;
  if ($[218] !== t) {
    t111 = t("products.termsAndConditions.description");
    $[218] = t;
    $[219] = t111;
  } else {
    t111 = $[219];
  }
  let t112;
  if ($[220] === Symbol.for("react.memo_cache_sentinel")) {
    t112 = <ClipboardIcon />;
    $[220] = t112;
  } else {
    t112 = $[220];
  }
  let t113;
  if ($[221] !== t) {
    t113 = t("products.termsAndConditions");
    $[221] = t;
    $[222] = t113;
  } else {
    t113 = $[222];
  }
  let t114;
  if ($[223] === Symbol.for("react.memo_cache_sentinel")) {
    t114 = LINKS();
    $[223] = t114;
  } else {
    t114 = $[223];
  }
  let t115;
  if ($[224] !== t111 || $[225] !== t113) {
    t115 = {
      id: "termsAndConditions",
      description: t111,
      icon: t112,
      name: t113,
      path: t114.termsAndConditions
    };
    $[224] = t111;
    $[225] = t113;
    $[226] = t115;
  } else {
    t115 = $[226];
  }
  let t116;
  if ($[227] !== t100 || $[228] !== t105 || $[229] !== t110 || $[230] !== t115) {
    t116 = [t100, t105, t110, t115];
    $[227] = t100;
    $[228] = t105;
    $[229] = t110;
    $[230] = t115;
    $[231] = t116;
  } else {
    t116 = $[231];
  }
  let t117;
  if ($[232] !== t116 || $[233] !== t95) {
    t117 = {
      id: "other",
      name: t95,
      subsection: t116
    };
    $[232] = t116;
    $[233] = t95;
    $[234] = t117;
  } else {
    t117 = $[234];
  }
  let t118;
  if ($[235] !== t117 || $[236] !== t27 || $[237] !== t30 || $[238] !== t48 || $[239] !== t71 || $[240] !== t94) {
    t118 = [t27, t30, t48, t71, t94, t117];
    $[235] = t117;
    $[236] = t27;
    $[237] = t30;
    $[238] = t48;
    $[239] = t71;
    $[240] = t94;
    $[241] = t118;
  } else {
    t118 = $[241];
  }
  const sectionsCs = t118 satisfies Section[];
  let t119;
  if ($[242] !== t) {
    t119 = t("products");
    $[242] = t;
    $[243] = t119;
  } else {
    t119 = $[243];
  }
  let t120;
  if ($[244] !== t) {
    t120 = t("products.payInThree.description");
    $[244] = t;
    $[245] = t120;
  } else {
    t120 = $[245];
  }
  let t121;
  if ($[246] === Symbol.for("react.memo_cache_sentinel")) {
    t121 = <ThirdIcon />;
    $[246] = t121;
  } else {
    t121 = $[246];
  }
  let t122;
  if ($[247] !== t) {
    t122 = t("products.payInThree");
    $[247] = t;
    $[248] = t122;
  } else {
    t122 = $[248];
  }
  let t123;
  if ($[249] === Symbol.for("react.memo_cache_sentinel")) {
    t123 = LINKS();
    $[249] = t123;
  } else {
    t123 = $[249];
  }
  let t124;
  if ($[250] !== t120 || $[251] !== t122) {
    t124 = {
      id: "payInThree",
      description: t120,
      icon: t121,
      name: t122,
      path: t123.payInThree
    };
    $[250] = t120;
    $[251] = t122;
    $[252] = t124;
  } else {
    t124 = $[252];
  }
  let t125;
  if ($[253] !== t) {
    t125 = t("products.mobileApp.description");
    $[253] = t;
    $[254] = t125;
  } else {
    t125 = $[254];
  }
  let t126;
  if ($[255] === Symbol.for("react.memo_cache_sentinel")) {
    t126 = <MobileAppIcon />;
    $[255] = t126;
  } else {
    t126 = $[255];
  }
  let t127;
  if ($[256] !== t) {
    t127 = t("products.mobileApp");
    $[256] = t;
    $[257] = t127;
  } else {
    t127 = $[257];
  }
  let t128;
  if ($[258] === Symbol.for("react.memo_cache_sentinel")) {
    t128 = LINKS();
    $[258] = t128;
  } else {
    t128 = $[258];
  }
  let t129;
  if ($[259] !== t125 || $[260] !== t127) {
    t129 = {
      id: "mobileApp",
      description: t125,
      icon: t126,
      name: t127,
      path: t128.mobileApp
    };
    $[259] = t125;
    $[260] = t127;
    $[261] = t129;
  } else {
    t129 = $[261];
  }
  let t130;
  if ($[262] !== t124 || $[263] !== t129) {
    t130 = [t124, t129];
    $[262] = t124;
    $[263] = t129;
    $[264] = t130;
  } else {
    t130 = $[264];
  }
  let t131;
  if ($[265] !== t119 || $[266] !== t130) {
    t131 = {
      id: "products",
      name: t119,
      subsection: t130
    };
    $[265] = t119;
    $[266] = t130;
    $[267] = t131;
  } else {
    t131 = $[267];
  }
  let t132;
  if ($[268] !== t) {
    t132 = t("products.whereToShop");
    $[268] = t;
    $[269] = t132;
  } else {
    t132 = $[269];
  }
  let t133;
  if ($[270] === Symbol.for("react.memo_cache_sentinel")) {
    t133 = LINKS();
    $[270] = t133;
  } else {
    t133 = $[270];
  }
  let t134;
  if ($[271] !== t132) {
    t134 = {
      id: "whereToShop",
      name: t132,
      path: t133.whereToShop
    };
    $[271] = t132;
    $[272] = t134;
  } else {
    t134 = $[272];
  }
  let t135;
  if ($[273] !== t) {
    t135 = t("products.implementation");
    $[273] = t;
    $[274] = t135;
  } else {
    t135 = $[274];
  }
  let t136;
  if ($[275] !== t) {
    t136 = t("products.forEshops.description");
    $[275] = t;
    $[276] = t136;
  } else {
    t136 = $[276];
  }
  let t137;
  if ($[277] === Symbol.for("react.memo_cache_sentinel")) {
    t137 = <ShoppingCartIcon />;
    $[277] = t137;
  } else {
    t137 = $[277];
  }
  let t138;
  if ($[278] !== t) {
    t138 = t("products.forEshops");
    $[278] = t;
    $[279] = t138;
  } else {
    t138 = $[279];
  }
  let t139;
  if ($[280] === Symbol.for("react.memo_cache_sentinel")) {
    t139 = LINKS();
    $[280] = t139;
  } else {
    t139 = $[280];
  }
  let t140;
  if ($[281] !== t136 || $[282] !== t138) {
    t140 = {
      id: "forEshops",
      description: t136,
      icon: t137,
      name: t138,
      path: t139.forEshops
    };
    $[281] = t136;
    $[282] = t138;
    $[283] = t140;
  } else {
    t140 = $[283];
  }
  let t141;
  if ($[284] !== t) {
    t141 = t("products.forDevelopers.description");
    $[284] = t;
    $[285] = t141;
  } else {
    t141 = $[285];
  }
  let t142;
  if ($[286] === Symbol.for("react.memo_cache_sentinel")) {
    t142 = <DesktopComputerIcon />;
    $[286] = t142;
  } else {
    t142 = $[286];
  }
  let t143;
  if ($[287] !== t) {
    t143 = t("products.forDevelopers");
    $[287] = t;
    $[288] = t143;
  } else {
    t143 = $[288];
  }
  let t144;
  if ($[289] === Symbol.for("react.memo_cache_sentinel")) {
    t144 = LINKS();
    $[289] = t144;
  } else {
    t144 = $[289];
  }
  let t145;
  if ($[290] !== t141 || $[291] !== t143) {
    t145 = {
      id: "forDevelopers",
      description: t141,
      icon: t142,
      name: t143,
      path: t144.forDevelopers
    };
    $[290] = t141;
    $[291] = t143;
    $[292] = t145;
  } else {
    t145 = $[292];
  }
  let t146;
  if ($[293] !== t) {
    t146 = t("products.checkoutManual.description");
    $[293] = t;
    $[294] = t146;
  } else {
    t146 = $[294];
  }
  let t147;
  if ($[295] === Symbol.for("react.memo_cache_sentinel")) {
    t147 = <TemplateIcon />;
    $[295] = t147;
  } else {
    t147 = $[295];
  }
  let t148;
  if ($[296] !== t) {
    t148 = t("products.checkoutManual");
    $[296] = t;
    $[297] = t148;
  } else {
    t148 = $[297];
  }
  let t149;
  if ($[298] === Symbol.for("react.memo_cache_sentinel")) {
    t149 = EXTERNAL_LINKS();
    $[298] = t149;
  } else {
    t149 = $[298];
  }
  let t150;
  if ($[299] !== t146 || $[300] !== t148) {
    t150 = {
      id: "checkoutManual",
      description: t146,
      icon: t147,
      name: t148,
      path: t149.checkoutManualSk
    };
    $[299] = t146;
    $[300] = t148;
    $[301] = t150;
  } else {
    t150 = $[301];
  }
  let t151;
  if ($[302] !== t140 || $[303] !== t145 || $[304] !== t150) {
    t151 = [t140, t145, t150];
    $[302] = t140;
    $[303] = t145;
    $[304] = t150;
    $[305] = t151;
  } else {
    t151 = $[305];
  }
  let t152;
  if ($[306] !== t135 || $[307] !== t151) {
    t152 = {
      id: "implementation",
      name: t135,
      subsection: t151
    };
    $[306] = t135;
    $[307] = t151;
    $[308] = t152;
  } else {
    t152 = $[308];
  }
  let t153;
  if ($[309] !== t) {
    t153 = t("products.aboutUs");
    $[309] = t;
    $[310] = t153;
  } else {
    t153 = $[310];
  }
  let t154;
  if ($[311] !== t) {
    t154 = t("products.aboutCompany.description");
    $[311] = t;
    $[312] = t154;
  } else {
    t154 = $[312];
  }
  let t155;
  if ($[313] === Symbol.for("react.memo_cache_sentinel")) {
    t155 = <UserGroupIcon />;
    $[313] = t155;
  } else {
    t155 = $[313];
  }
  let t156;
  if ($[314] !== t) {
    t156 = t("products.aboutCompany");
    $[314] = t;
    $[315] = t156;
  } else {
    t156 = $[315];
  }
  let t157;
  if ($[316] === Symbol.for("react.memo_cache_sentinel")) {
    t157 = LINKS();
    $[316] = t157;
  } else {
    t157 = $[316];
  }
  let t158;
  if ($[317] !== t154 || $[318] !== t156) {
    t158 = {
      id: "aboutCompany",
      description: t154,
      icon: t155,
      name: t156,
      path: t157.aboutCompany
    };
    $[317] = t154;
    $[318] = t156;
    $[319] = t158;
  } else {
    t158 = $[319];
  }
  let t159;
  if ($[320] !== t) {
    t159 = t("products.forMedia.description");
    $[320] = t;
    $[321] = t159;
  } else {
    t159 = $[321];
  }
  let t160;
  if ($[322] === Symbol.for("react.memo_cache_sentinel")) {
    t160 = <BookOpenIcon />;
    $[322] = t160;
  } else {
    t160 = $[322];
  }
  let t161;
  if ($[323] !== t) {
    t161 = t("products.forMedia");
    $[323] = t;
    $[324] = t161;
  } else {
    t161 = $[324];
  }
  let t162;
  if ($[325] === Symbol.for("react.memo_cache_sentinel")) {
    t162 = LINKS();
    $[325] = t162;
  } else {
    t162 = $[325];
  }
  let t163;
  if ($[326] !== t159 || $[327] !== t161) {
    t163 = {
      id: "forMedia",
      description: t159,
      icon: t160,
      name: t161,
      path: t162.forMedia
    };
    $[326] = t159;
    $[327] = t161;
    $[328] = t163;
  } else {
    t163 = $[328];
  }
  let t164;
  if ($[329] !== t158 || $[330] !== t163) {
    t164 = [t158, t163];
    $[329] = t158;
    $[330] = t163;
    $[331] = t164;
  } else {
    t164 = $[331];
  }
  let t165;
  if ($[332] !== t153 || $[333] !== t164) {
    t165 = {
      id: "aboutUs",
      name: t153,
      subsection: t164
    };
    $[332] = t153;
    $[333] = t164;
    $[334] = t165;
  } else {
    t165 = $[334];
  }
  let t166;
  if ($[335] !== t) {
    t166 = t("products.other");
    $[335] = t;
    $[336] = t166;
  } else {
    t166 = $[336];
  }
  let t167;
  if ($[337] !== t) {
    t167 = t("products.faq.description");
    $[337] = t;
    $[338] = t167;
  } else {
    t167 = $[338];
  }
  let t168;
  if ($[339] === Symbol.for("react.memo_cache_sentinel")) {
    t168 = <ChatIcon />;
    $[339] = t168;
  } else {
    t168 = $[339];
  }
  let t169;
  if ($[340] !== t) {
    t169 = t("products.faq");
    $[340] = t;
    $[341] = t169;
  } else {
    t169 = $[341];
  }
  let t170;
  if ($[342] === Symbol.for("react.memo_cache_sentinel")) {
    t170 = LINKS();
    $[342] = t170;
  } else {
    t170 = $[342];
  }
  let t171;
  if ($[343] !== t167 || $[344] !== t169) {
    t171 = {
      id: "faq",
      description: t167,
      icon: t168,
      name: t169,
      path: t170.faq
    };
    $[343] = t167;
    $[344] = t169;
    $[345] = t171;
  } else {
    t171 = $[345];
  }
  let t172;
  if ($[346] !== t) {
    t172 = t("products.pricing.description");
    $[346] = t;
    $[347] = t172;
  } else {
    t172 = $[347];
  }
  let t173;
  if ($[348] === Symbol.for("react.memo_cache_sentinel")) {
    t173 = <PayIcon />;
    $[348] = t173;
  } else {
    t173 = $[348];
  }
  let t174;
  if ($[349] !== t) {
    t174 = t("products.pricing");
    $[349] = t;
    $[350] = t174;
  } else {
    t174 = $[350];
  }
  let t175;
  if ($[351] === Symbol.for("react.memo_cache_sentinel")) {
    t175 = LINKS();
    $[351] = t175;
  } else {
    t175 = $[351];
  }
  let t176;
  if ($[352] !== t172 || $[353] !== t174) {
    t176 = {
      id: "pricing",
      description: t172,
      icon: t173,
      name: t174,
      path: t175.pricing
    };
    $[352] = t172;
    $[353] = t174;
    $[354] = t176;
  } else {
    t176 = $[354];
  }
  let t177;
  if ($[355] !== t) {
    t177 = t("products.contact.description");
    $[355] = t;
    $[356] = t177;
  } else {
    t177 = $[356];
  }
  let t178;
  if ($[357] === Symbol.for("react.memo_cache_sentinel")) {
    t178 = <PhoneIcon />;
    $[357] = t178;
  } else {
    t178 = $[357];
  }
  let t179;
  if ($[358] !== t) {
    t179 = t("products.contact");
    $[358] = t;
    $[359] = t179;
  } else {
    t179 = $[359];
  }
  let t180;
  if ($[360] === Symbol.for("react.memo_cache_sentinel")) {
    t180 = LINKS();
    $[360] = t180;
  } else {
    t180 = $[360];
  }
  let t181;
  if ($[361] !== t177 || $[362] !== t179) {
    t181 = {
      id: "contact",
      description: t177,
      icon: t178,
      name: t179,
      path: t180.contact
    };
    $[361] = t177;
    $[362] = t179;
    $[363] = t181;
  } else {
    t181 = $[363];
  }
  let t182;
  if ($[364] !== t) {
    t182 = t("products.termsAndConditions.description");
    $[364] = t;
    $[365] = t182;
  } else {
    t182 = $[365];
  }
  let t183;
  if ($[366] === Symbol.for("react.memo_cache_sentinel")) {
    t183 = <ClipboardIcon />;
    $[366] = t183;
  } else {
    t183 = $[366];
  }
  let t184;
  if ($[367] !== t) {
    t184 = t("products.termsAndConditions");
    $[367] = t;
    $[368] = t184;
  } else {
    t184 = $[368];
  }
  let t185;
  if ($[369] === Symbol.for("react.memo_cache_sentinel")) {
    t185 = LINKS();
    $[369] = t185;
  } else {
    t185 = $[369];
  }
  let t186;
  if ($[370] !== t182 || $[371] !== t184) {
    t186 = {
      id: "termsAndConditions",
      description: t182,
      icon: t183,
      name: t184,
      path: t185.termsAndConditions
    };
    $[370] = t182;
    $[371] = t184;
    $[372] = t186;
  } else {
    t186 = $[372];
  }
  let t187;
  if ($[373] !== t171 || $[374] !== t176 || $[375] !== t181 || $[376] !== t186) {
    t187 = [t171, t176, t181, t186];
    $[373] = t171;
    $[374] = t176;
    $[375] = t181;
    $[376] = t186;
    $[377] = t187;
  } else {
    t187 = $[377];
  }
  let t188;
  if ($[378] !== t166 || $[379] !== t187) {
    t188 = {
      id: "other",
      name: t166,
      promo: undefined,
      subsection: t187
    };
    $[378] = t166;
    $[379] = t187;
    $[380] = t188;
  } else {
    t188 = $[380];
  }
  let t189;
  if ($[381] !== t131 || $[382] !== t134 || $[383] !== t152 || $[384] !== t165 || $[385] !== t188) {
    t189 = [t131, t134, t152, t165, t188];
    $[381] = t131;
    $[382] = t134;
    $[383] = t152;
    $[384] = t165;
    $[385] = t188;
    $[386] = t189;
  } else {
    t189 = $[386];
  }
  const sectionsSk = t189 satisfies Section[];
  let t190;
  if ($[387] !== t) {
    t190 = t("products");
    $[387] = t;
    $[388] = t190;
  } else {
    t190 = $[388];
  }
  let t191;
  if ($[389] !== t) {
    t191 = t("products.payInThree.description");
    $[389] = t;
    $[390] = t191;
  } else {
    t191 = $[390];
  }
  let t192;
  if ($[391] === Symbol.for("react.memo_cache_sentinel")) {
    t192 = <ThirdIcon />;
    $[391] = t192;
  } else {
    t192 = $[391];
  }
  let t193;
  if ($[392] !== t) {
    t193 = t("products.payInThree");
    $[392] = t;
    $[393] = t193;
  } else {
    t193 = $[393];
  }
  let t194;
  if ($[394] === Symbol.for("react.memo_cache_sentinel")) {
    t194 = LINKS();
    $[394] = t194;
  } else {
    t194 = $[394];
  }
  let t195;
  if ($[395] !== t191 || $[396] !== t193) {
    t195 = {
      id: "payInThree",
      description: t191,
      icon: t192,
      name: t193,
      path: t194.payInThree
    };
    $[395] = t191;
    $[396] = t193;
    $[397] = t195;
  } else {
    t195 = $[397];
  }
  let t196;
  if ($[398] !== t) {
    t196 = t("products.mobileApp.description");
    $[398] = t;
    $[399] = t196;
  } else {
    t196 = $[399];
  }
  let t197;
  if ($[400] === Symbol.for("react.memo_cache_sentinel")) {
    t197 = <MobileAppIcon />;
    $[400] = t197;
  } else {
    t197 = $[400];
  }
  let t198;
  if ($[401] !== t) {
    t198 = t("products.mobileApp");
    $[401] = t;
    $[402] = t198;
  } else {
    t198 = $[402];
  }
  let t199;
  if ($[403] === Symbol.for("react.memo_cache_sentinel")) {
    t199 = LINKS();
    $[403] = t199;
  } else {
    t199 = $[403];
  }
  let t200;
  if ($[404] !== t196 || $[405] !== t198) {
    t200 = {
      id: "mobileApp",
      description: t196,
      icon: t197,
      name: t198,
      path: t199.mobileApp
    };
    $[404] = t196;
    $[405] = t198;
    $[406] = t200;
  } else {
    t200 = $[406];
  }
  let t201;
  if ($[407] !== t195 || $[408] !== t200) {
    t201 = [t195, t200];
    $[407] = t195;
    $[408] = t200;
    $[409] = t201;
  } else {
    t201 = $[409];
  }
  let t202;
  if ($[410] !== t190 || $[411] !== t201) {
    t202 = {
      id: "products",
      name: t190,
      subsection: t201
    };
    $[410] = t190;
    $[411] = t201;
    $[412] = t202;
  } else {
    t202 = $[412];
  }
  let t203;
  if ($[413] !== t) {
    t203 = t("products.whereToShop");
    $[413] = t;
    $[414] = t203;
  } else {
    t203 = $[414];
  }
  let t204;
  if ($[415] === Symbol.for("react.memo_cache_sentinel")) {
    t204 = LINKS();
    $[415] = t204;
  } else {
    t204 = $[415];
  }
  let t205;
  if ($[416] !== t203) {
    t205 = {
      id: "whereToShop",
      name: t203,
      path: t204.whereToShop
    };
    $[416] = t203;
    $[417] = t205;
  } else {
    t205 = $[417];
  }
  let t206;
  if ($[418] !== t) {
    t206 = t("products.implementation");
    $[418] = t;
    $[419] = t206;
  } else {
    t206 = $[419];
  }
  let t207;
  if ($[420] !== t) {
    t207 = t("products.forEshops.description");
    $[420] = t;
    $[421] = t207;
  } else {
    t207 = $[421];
  }
  let t208;
  if ($[422] === Symbol.for("react.memo_cache_sentinel")) {
    t208 = <ShoppingCartIcon />;
    $[422] = t208;
  } else {
    t208 = $[422];
  }
  let t209;
  if ($[423] !== t) {
    t209 = t("products.forEshops");
    $[423] = t;
    $[424] = t209;
  } else {
    t209 = $[424];
  }
  let t210;
  if ($[425] === Symbol.for("react.memo_cache_sentinel")) {
    t210 = LINKS();
    $[425] = t210;
  } else {
    t210 = $[425];
  }
  let t211;
  if ($[426] !== t207 || $[427] !== t209) {
    t211 = {
      id: "forEshops",
      description: t207,
      icon: t208,
      name: t209,
      path: t210.forEshops
    };
    $[426] = t207;
    $[427] = t209;
    $[428] = t211;
  } else {
    t211 = $[428];
  }
  let t212;
  if ($[429] !== t) {
    t212 = t("products.forDevelopers.description");
    $[429] = t;
    $[430] = t212;
  } else {
    t212 = $[430];
  }
  let t213;
  if ($[431] === Symbol.for("react.memo_cache_sentinel")) {
    t213 = <DesktopComputerIcon />;
    $[431] = t213;
  } else {
    t213 = $[431];
  }
  let t214;
  if ($[432] !== t) {
    t214 = t("products.forDevelopers");
    $[432] = t;
    $[433] = t214;
  } else {
    t214 = $[433];
  }
  let t215;
  if ($[434] === Symbol.for("react.memo_cache_sentinel")) {
    t215 = LINKS();
    $[434] = t215;
  } else {
    t215 = $[434];
  }
  let t216;
  if ($[435] !== t212 || $[436] !== t214) {
    t216 = {
      id: "forDevelopers",
      description: t212,
      icon: t213,
      name: t214,
      path: t215.forDevelopers
    };
    $[435] = t212;
    $[436] = t214;
    $[437] = t216;
  } else {
    t216 = $[437];
  }
  let t217;
  if ($[438] !== t) {
    t217 = t("products.checkoutManual.description");
    $[438] = t;
    $[439] = t217;
  } else {
    t217 = $[439];
  }
  let t218;
  if ($[440] === Symbol.for("react.memo_cache_sentinel")) {
    t218 = <TemplateIcon />;
    $[440] = t218;
  } else {
    t218 = $[440];
  }
  let t219;
  if ($[441] !== t) {
    t219 = t("products.checkoutManual");
    $[441] = t;
    $[442] = t219;
  } else {
    t219 = $[442];
  }
  let t220;
  if ($[443] === Symbol.for("react.memo_cache_sentinel")) {
    t220 = EXTERNAL_LINKS();
    $[443] = t220;
  } else {
    t220 = $[443];
  }
  let t221;
  if ($[444] !== t217 || $[445] !== t219) {
    t221 = {
      id: "checkoutManual",
      description: t217,
      icon: t218,
      name: t219,
      path: t220.checkoutManualHu
    };
    $[444] = t217;
    $[445] = t219;
    $[446] = t221;
  } else {
    t221 = $[446];
  }
  let t222;
  if ($[447] !== t211 || $[448] !== t216 || $[449] !== t221) {
    t222 = [t211, t216, t221];
    $[447] = t211;
    $[448] = t216;
    $[449] = t221;
    $[450] = t222;
  } else {
    t222 = $[450];
  }
  let t223;
  if ($[451] !== t206 || $[452] !== t222) {
    t223 = {
      id: "implementation",
      name: t206,
      subsection: t222
    };
    $[451] = t206;
    $[452] = t222;
    $[453] = t223;
  } else {
    t223 = $[453];
  }
  let t224;
  if ($[454] !== t) {
    t224 = t("products.aboutUs");
    $[454] = t;
    $[455] = t224;
  } else {
    t224 = $[455];
  }
  let t225;
  if ($[456] !== t) {
    t225 = t("products.aboutCompany.description");
    $[456] = t;
    $[457] = t225;
  } else {
    t225 = $[457];
  }
  let t226;
  if ($[458] === Symbol.for("react.memo_cache_sentinel")) {
    t226 = <UserGroupIcon />;
    $[458] = t226;
  } else {
    t226 = $[458];
  }
  let t227;
  if ($[459] !== t) {
    t227 = t("products.aboutCompany");
    $[459] = t;
    $[460] = t227;
  } else {
    t227 = $[460];
  }
  let t228;
  if ($[461] === Symbol.for("react.memo_cache_sentinel")) {
    t228 = LINKS();
    $[461] = t228;
  } else {
    t228 = $[461];
  }
  let t229;
  if ($[462] !== t225 || $[463] !== t227) {
    t229 = {
      id: "aboutCompany",
      description: t225,
      icon: t226,
      name: t227,
      path: t228.aboutCompany
    };
    $[462] = t225;
    $[463] = t227;
    $[464] = t229;
  } else {
    t229 = $[464];
  }
  let t230;
  if ($[465] !== t) {
    t230 = t("products.forMedia.description");
    $[465] = t;
    $[466] = t230;
  } else {
    t230 = $[466];
  }
  let t231;
  if ($[467] === Symbol.for("react.memo_cache_sentinel")) {
    t231 = <BookOpenIcon />;
    $[467] = t231;
  } else {
    t231 = $[467];
  }
  let t232;
  if ($[468] !== t) {
    t232 = t("products.forMedia");
    $[468] = t;
    $[469] = t232;
  } else {
    t232 = $[469];
  }
  let t233;
  if ($[470] === Symbol.for("react.memo_cache_sentinel")) {
    t233 = LINKS();
    $[470] = t233;
  } else {
    t233 = $[470];
  }
  let t234;
  if ($[471] !== t230 || $[472] !== t232) {
    t234 = {
      id: "forMedia",
      description: t230,
      icon: t231,
      name: t232,
      path: t233.forMedia
    };
    $[471] = t230;
    $[472] = t232;
    $[473] = t234;
  } else {
    t234 = $[473];
  }
  let t235;
  if ($[474] !== t229 || $[475] !== t234) {
    t235 = [t229, t234];
    $[474] = t229;
    $[475] = t234;
    $[476] = t235;
  } else {
    t235 = $[476];
  }
  let t236;
  if ($[477] !== t224 || $[478] !== t235) {
    t236 = {
      id: "aboutUs",
      name: t224,
      subsection: t235
    };
    $[477] = t224;
    $[478] = t235;
    $[479] = t236;
  } else {
    t236 = $[479];
  }
  let t237;
  if ($[480] !== t) {
    t237 = t("products.other");
    $[480] = t;
    $[481] = t237;
  } else {
    t237 = $[481];
  }
  let t238;
  if ($[482] !== t) {
    t238 = t("products.faq.description");
    $[482] = t;
    $[483] = t238;
  } else {
    t238 = $[483];
  }
  let t239;
  if ($[484] === Symbol.for("react.memo_cache_sentinel")) {
    t239 = <ChatIcon />;
    $[484] = t239;
  } else {
    t239 = $[484];
  }
  let t240;
  if ($[485] !== t) {
    t240 = t("products.faq");
    $[485] = t;
    $[486] = t240;
  } else {
    t240 = $[486];
  }
  let t241;
  if ($[487] === Symbol.for("react.memo_cache_sentinel")) {
    t241 = LINKS();
    $[487] = t241;
  } else {
    t241 = $[487];
  }
  let t242;
  if ($[488] !== t238 || $[489] !== t240) {
    t242 = {
      id: "faq",
      description: t238,
      icon: t239,
      name: t240,
      path: t241.faq
    };
    $[488] = t238;
    $[489] = t240;
    $[490] = t242;
  } else {
    t242 = $[490];
  }
  let t243;
  if ($[491] !== t) {
    t243 = t("products.pricing.description");
    $[491] = t;
    $[492] = t243;
  } else {
    t243 = $[492];
  }
  let t244;
  if ($[493] === Symbol.for("react.memo_cache_sentinel")) {
    t244 = <PayIcon />;
    $[493] = t244;
  } else {
    t244 = $[493];
  }
  let t245;
  if ($[494] !== t) {
    t245 = t("products.pricing");
    $[494] = t;
    $[495] = t245;
  } else {
    t245 = $[495];
  }
  let t246;
  if ($[496] === Symbol.for("react.memo_cache_sentinel")) {
    t246 = LINKS();
    $[496] = t246;
  } else {
    t246 = $[496];
  }
  let t247;
  if ($[497] !== t243 || $[498] !== t245) {
    t247 = {
      id: "pricing",
      description: t243,
      icon: t244,
      name: t245,
      path: t246.pricing
    };
    $[497] = t243;
    $[498] = t245;
    $[499] = t247;
  } else {
    t247 = $[499];
  }
  let t248;
  if ($[500] !== t) {
    t248 = t("products.contact.description");
    $[500] = t;
    $[501] = t248;
  } else {
    t248 = $[501];
  }
  let t249;
  if ($[502] === Symbol.for("react.memo_cache_sentinel")) {
    t249 = <PhoneIcon />;
    $[502] = t249;
  } else {
    t249 = $[502];
  }
  let t250;
  if ($[503] !== t) {
    t250 = t("products.contact");
    $[503] = t;
    $[504] = t250;
  } else {
    t250 = $[504];
  }
  let t251;
  if ($[505] === Symbol.for("react.memo_cache_sentinel")) {
    t251 = LINKS();
    $[505] = t251;
  } else {
    t251 = $[505];
  }
  let t252;
  if ($[506] !== t248 || $[507] !== t250) {
    t252 = {
      id: "contact",
      description: t248,
      icon: t249,
      name: t250,
      path: t251.contact
    };
    $[506] = t248;
    $[507] = t250;
    $[508] = t252;
  } else {
    t252 = $[508];
  }
  let t253;
  if ($[509] !== t) {
    t253 = t("products.termsAndConditions.description");
    $[509] = t;
    $[510] = t253;
  } else {
    t253 = $[510];
  }
  let t254;
  if ($[511] === Symbol.for("react.memo_cache_sentinel")) {
    t254 = <ClipboardIcon />;
    $[511] = t254;
  } else {
    t254 = $[511];
  }
  let t255;
  if ($[512] !== t) {
    t255 = t("products.termsAndConditions");
    $[512] = t;
    $[513] = t255;
  } else {
    t255 = $[513];
  }
  let t256;
  if ($[514] === Symbol.for("react.memo_cache_sentinel")) {
    t256 = LINKS();
    $[514] = t256;
  } else {
    t256 = $[514];
  }
  let t257;
  if ($[515] !== t253 || $[516] !== t255) {
    t257 = {
      id: "termsAndConditions",
      description: t253,
      icon: t254,
      name: t255,
      path: t256.termsAndConditions
    };
    $[515] = t253;
    $[516] = t255;
    $[517] = t257;
  } else {
    t257 = $[517];
  }
  let t258;
  if ($[518] !== t242 || $[519] !== t247 || $[520] !== t252 || $[521] !== t257) {
    t258 = [t242, t247, t252, t257];
    $[518] = t242;
    $[519] = t247;
    $[520] = t252;
    $[521] = t257;
    $[522] = t258;
  } else {
    t258 = $[522];
  }
  let t259;
  if ($[523] !== t237 || $[524] !== t258) {
    t259 = {
      id: "other",
      name: t237,
      promo: undefined,
      subsection: t258
    };
    $[523] = t237;
    $[524] = t258;
    $[525] = t259;
  } else {
    t259 = $[525];
  }
  let t260;
  if ($[526] !== t202 || $[527] !== t205 || $[528] !== t223 || $[529] !== t236 || $[530] !== t259) {
    t260 = [t202, t205, t223, t236, t259];
    $[526] = t202;
    $[527] = t205;
    $[528] = t223;
    $[529] = t236;
    $[530] = t259;
    $[531] = t260;
  } else {
    t260 = $[531];
  }
  const sectionsHu = t260 satisfies Section[];
  return isCsLanguage ? sectionsCs : isHuLanguage ? sectionsHu : sectionsSk;
}